import { ArrowRight, PhoneCall, Scale, ShieldCheck, Lock } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { GoldParticles } from "../components/GoldParticles";
import { TRUST_URL } from "../lib/constants";

const ASSURANCES = [
  { icon: PhoneCall, text: "Personal call before you pay." },
  { icon: Scale, text: "Military legal review included." },
  { icon: ShieldCheck, text: "Protection in place from day one." },
];

export const FinalCTA = () => (
  <section className="relative bg-ink py-28 sm:py-44 overflow-hidden" data-testid="final-cta-section">
    <div className="absolute inset-0">
      <img
        src="https://images.unsplash.com/photo-1624448445915-97154f5e688c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
        alt=""
        aria-hidden="true"
        className="w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/85 to-ink" />
    </div>
    <GoldParticles />
    <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-cream tracking-tight leading-[1.05]">
          Own Nothing. <span className="block text-gold italic mt-2">Control Everything.</span>
        </h2>
        <p className="text-cream/75 text-base sm:text-lg leading-relaxed mt-8 max-w-2xl mx-auto">
          Go through the portal at your own pace. See everything set up before you pay a single dollar. You
          will receive a personal call before anything finalizes.
        </p>
        <div
          className="max-w-2xl mx-auto mt-12 bg-surface/70 backdrop-blur-sm border border-gold/25 rounded-2xl px-7 sm:px-10 py-7 text-left sm:text-center"
          data-testid="security-promise"
        >
          <div className="flex items-center justify-start sm:justify-center gap-2.5 text-gold text-xs tracking-[0.28em] uppercase font-semibold">
            <Lock size={14} /> Your Information Is Safe
          </div>
          <p className="text-cream/80 text-sm sm:text-base leading-relaxed mt-4">
            Your information is protected with military grade encryption. We never sell or share your data.
            Your SSN is secured the moment it is entered and is only accessible to your case administrator.
          </p>
          <p className="font-display italic text-gold text-base sm:text-lg mt-3">
            This is not just policy. This is our promise.
          </p>
        </div>
        <a
          href={TRUST_URL}
          data-testid="final-cta-btn"
          className="group inline-flex items-center gap-3 bg-gold text-ink font-bold tracking-[0.1em] uppercase text-sm sm:text-base px-10 py-5 rounded-full mt-10 hover:bg-goldlight transition-colors duration-300 shadow-[0_0_60px_rgba(201,162,60,0.45)]"
        >
          Start Your Portal Now
          <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1.5" />
        </a>
        <div className="flex flex-col sm:flex-row justify-center gap-5 sm:gap-10 mt-14">
          {ASSURANCES.map(({ icon: Icon, text }) => (
            <div key={text} className="flex items-center justify-center gap-2.5 text-cream/70 text-sm">
              <Icon size={16} className="text-gold" /> {text}
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
